import React, {useContext} from 'react';
import {find, groupBy, map} from 'lodash';
import {useDispatch, useSelector} from 'react-redux';

import {useMediaQuery} from 'src/hooks/use-media-query';
import {withCommas} from 'shared/utils';
import {SCHOLARSHIP_TYPE_MAP} from './constants';
import {changeScholarshipProgram} from 'shared/college-profile/actions/college-profile';
import {Store} from 'src/types/store';

import {PathDesignContext} from 'src/components/path-design-context';
import ScholarshipType from './scholarship-type';
import EligibilityCriteriaCard from '../right-rail/eligibility-criteria-card';
import EnrollmentCriteriaCard from '../right-rail/enrollment-criteria-card';
import Card from 'src/components/cards/card';
import Dropdown from 'src/components/dropdown';
import SectionHeader from 'shared/college-profile/components/section-header';
import EllucianDropdown from 'src/components/ellucian/dropdown';

const NonStudentScholarships = () => {
  const dispatch = useDispatch();
  const mq = useMediaQuery();
  const path = useContext(PathDesignContext);
  const {
    activeScholarshipProgram,
    userInfo,
    college: {scholarshipPrograms},
  } = useSelector((state: Store) => state.collegeProfile);

  const handleProgramSelect = (e) => {
    dispatch(changeScholarshipProgram(e.target.value));
  };

  const displayMax = (max) => `- $${withCommas(max)} Maximum`;

  const scholarshipProgram = activeScholarshipProgram.name
    ? find(scholarshipPrograms, {name: activeScholarshipProgram.name})
    : scholarshipPrograms[0];

  const groupedScholarships = groupBy(
    scholarshipProgram?.scholarships,
    (scholarship) => SCHOLARSHIP_TYPE_MAP[scholarship._type]
  );

  return (
    <div className="college-profile-scholarship-breakdown">
      <div className="college-profile-educator-scholarship-header">
        {scholarshipPrograms.length > 1 ? (
          <>
            {path.enabled ? (
              <EllucianDropdown
                label="Scholarship Programs"
                options={scholarshipPrograms.map((program) => ({
                  label: `${program.name} ${displayMax(program.maxPerStudent)}`,
                  value: program.name,
                }))}
                value={activeScholarshipProgram.name || scholarshipProgram?.name}
                onChange={handleProgramSelect}
                fullWidth
              />
            ) : (
              <Dropdown
                options={map(scholarshipPrograms, (program) => ({
                  _id: program.name,
                  value: program.name,
                  text: `${program.name} ${displayMax(program.maxPerStudent)}`,
                }))}
                value={activeScholarshipProgram.name || scholarshipProgram?.name}
                onChange={handleProgramSelect}
              />
            )}
          </>
        ) : (
          <SectionHeader
            title={`${scholarshipProgram?.name} ${displayMax(scholarshipProgram?.maxPerStudent)}`}
          />
        )}
      </div>
      {mq.SM_AND_DOWN && (
        <>
          <EligibilityCriteriaCard scholarshipProgram={scholarshipProgram} />
          <EnrollmentCriteriaCard ongoingRequirements={scholarshipProgram?.ongoingRequirements} />
        </>
      )}
      {map(Object.keys(groupedScholarships), (type) => {
        if (type === 'hidden') {
          return null;
        }

        return (
          <Card key={type}>
            <ScholarshipType
              awardsReplaced={false}
              scholarships={groupedScholarships[type]}
              type={type}
              submitted={false}
              educator
              userInfo={userInfo}
            />
          </Card>
        );
      })}
    </div>
  );
};

export default NonStudentScholarships;
